import { Search, X } from 'lucide-react';

/**
 * Champ de recherche contrôlé, présentationnel. Le PRÉDICAT de filtrage reste
 * chez l'appelant — ce composant ne fait que l'UI (input + icône + bouton effacer).
 *
 * @param {string} value
 * @param {(v: string) => void} onChange  reçoit la nouvelle valeur
 * @param {string} [placeholder]
 * @param {() => void} [onClear]  par défaut : onChange('')
 * @param {string} [className]    classes du conteneur (largeur, flex…)
 */
const BarreRecherche = ({ value, onChange, placeholder = 'Rechercher…', onClear, className = '' }) => (
  <div className={`relative ${className}`}>
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full pl-10 pr-9 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-400"
    />
    {value ? (
      <button
        type="button"
        onClick={() => (onClear ? onClear() : onChange(''))}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1 rounded-lg hover:bg-gray-200 transition-colors"
        title="Effacer"
      >
        <X className="w-4 h-4 text-gray-400" />
      </button>
    ) : null}
  </div>
);

export default BarreRecherche;
